var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ib-handwriting-wrapper d-flex align-items-center",class:{'flex-row-reverse': _vm.reverse}},[_c(_vm.tag,{tag:"component",staticClass:"ib-handwriting-text font-tragic-marker text-primary-color"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("arrow")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }